// Hash each stream position independently, so columns cannot become shifted
// copies of the alphabet. A moving glyph keeps its character between frames.
module.exports = function glyphIndex(column, row, length) {
  let value = Math.imul(column, 0x9e3779b1) ^ Math.imul(row, 0x85ebca6b);
  value = Math.imul(value ^ (value >>> 16), 0x7feb352d);
  value = Math.imul(value ^ (value >>> 15), 0x846ca68b);
  return ((value ^ (value >>> 16)) >>> 0) % length;
};
